import { TaskType } from "@common/types/task";
import styles from "../CloseTemplateTasksDrawer.module.scss";
import { hasFullscreenPreview } from "./templateTaskPreview";
import {
    TEMPLATE_PREVIEW_BY_TASK_TYPE,
    TemplateTaskPreviewProps,
} from "./templateTaskPreviewComponents";

interface TemplateTaskPreviewPaneProps extends Omit<
    TemplateTaskPreviewProps,
    "taskType"
> {
    taskType: TaskType | null;
    previewKey: string;
}

export const TemplateTaskPreviewPane = ({
    taskType,
    previewKey,
    ...previewProps
}: TemplateTaskPreviewPaneProps) => {
    const Preview = taskType ? TEMPLATE_PREVIEW_BY_TASK_TYPE[taskType] : null;
    if (!taskType || !Preview || !hasFullscreenPreview(taskType)) {
        return null;
    }

    return (
        <div className={styles.addTaskDrawerRightContentWrapper}>
            <div className={styles.addTaskDrawerRightContent}>
                <Preview
                    key={previewKey}
                    taskType={taskType}
                    {...previewProps}
                />
            </div>
        </div>
    );
};
